<script>
export default {
    name: 'Modal',
    props: ['show']
}
</script>

<template>
    <div v-if="show" class="modal-mask">
        <div class="modal-container">
            <div>
                <slot>default body</slot>
            </div>

            <footer class="modal-footer">
                <button
                    type="button"
                    class="button cancel"
                    aria-label="Cancel"
                    @click="$emit('close')"
                >
                    Cancel
                </button>

                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<style>
.modal-mask {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .6);
    display: grid;
    place-items: center;
}

.modal-container {
    position: relative;
    background: white;
    padding: 1rem;
    width: 80vw;
    max-width: 500px;
    border-radius: 7px;
}

.modal-header {
    display: flex;
    justify-content: flex-end;
    margin: -0.25rem -0.25rem 0.5rem;
}

.modal-body {
    /* keeps structure explicit; no visual changes required */
}

.modal-footer {
    border-top: 1px solid #ddd;
    margin-top: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: .8rem;
}

.modal-footer button.cancel {
    background: #7A808747;
    color: white;
    padding: 0.5rem 2rem;
    border: 0;
    border-radius: 2px;
    margin: 0;
    font-size: 1rem;
}

.modal-footer button.submit {
    background: #28a745;
    color: white;
    padding: 0.5rem 2rem;
    border: 0;
    border-radius: 2px;
    margin: 0;
    font-size: 1rem;
}

.modal-footer button:hover {
    cursor: pointer;
    color: #000;
}
</style>
